













import Vue from "vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "AutomationScheduleModal",
  data() {
    return {
      title: "Automation schedule",
      columns: [
        {
          label: "Date",
          field: "from_date",
          width: "150px",
        },
        {
          label: "School ids",
          field: "school_ids",
        },
        {
          label: "Selection",
          field: "school_selection",
        },
        {
          label: "Created at",
          field: "created_at",
          width: "140px",
          // type: "date",
          // dateInputFormat: "yyyy-MM-dd",
          // dateOutputFormat: "MMM do yy",
        },
      ],
      data: [],
    };
  },
  components: {
    HeaderComponent,
  },
  props: {
    id: Number,
  },
  methods: {
    getAutomationSchedule(id) {
      ApiService.automationsApi.getAutomationSchedule(this.id).then((resp) => {
        this.data = resp.data;
      });
    },
  },
  mounted() {
    // this.title = this.name + " - Stats";
    this.getAutomationSchedule();
  },
});
